import loadable from '@loadable/component';
import { loadableOptions } from '@utils/helpers';

const Common = {
  Prescription: loadable(() => import('./Prescription'), loadableOptions),
};

export default Common;
